"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var Text_1 = __importDefault(require("../../Text/Text"));
var TopBarIconButton_1 = __importDefault(require("./_base/TopBarIconButton"));
var TopBarAppSwitcher_1 = __importDefault(require("./_base/TopBarAppSwitcher"));
var TopBarAvatar_1 = __importDefault(require("./_base/TopBarAvatar"));
var TopBarLayout_1 = __importDefault(require("./_base/TopBarLayout/TopBarLayout"));
var MaintenanceMessage_1 = __importDefault(require("../../MaintenanceMessage/MaintenanceMessage"));
var styles = {
    container: react_1.css({
        padding: style_1.pxToRem(6, 16) + " var(" + variables_1.Spacing.sp24 + ")",
        background: "var(" + variables_1.RootColor.White + ")",
        borderBottom: "1px solid var(" + variables_1.BorderColor.GRAY_LIGHT_3 + ")",
        minHeight: 52,
    }),
};
var TopBar = function (_a) {
    var title = _a.title, children = _a.children, currentApp = _a.currentApp;
    return (react_1.jsx(layout_1.Flex, { direction: 'column', "data-6si-name": "top-bar" },
        react_1.jsx(layout_1.Flex, { css: styles.container, alignItems: "center", justifyContent: "space-between" },
            react_1.jsx(Text_1.default.Title, { size: "xl", color: "var(" + variables_1.TextColor.HEAD + ")" }, title),
            react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 8 }, children)),
        react_1.jsx(MaintenanceMessage_1.default, { currentApp: currentApp })));
};
exports.default = Object.assign(TopBar, {
    IconButton: TopBarIconButton_1.default,
    AppSwitcher: TopBarAppSwitcher_1.default,
    Avatar: TopBarAvatar_1.default,
    Layout: TopBarLayout_1.default,
});
